<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <div class="justify-content-center">
        <b-card no-body class="bg-secondary">
          <b-card-body class="px-lg-5 py-lg-5">
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <base-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-hat-3"
                  placeholder="Nombre"
                  name="Nombre"
                  :rules="{ required: true }"
                  v-model="nombre"
                >
                </base-input>

                <base-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-email-83"
                  placeholder="Email"
                  name="Email"
                  :rules="{ required: true, email: true }"
                  v-model="email"
                >
                </base-input>

                <base-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  placeholder="password"
                  type="password"
                  name="Password"
                  v-model="password"
                >
                </base-input>
                <div class="text-center">
                  <b-button type="submit" variant="primary" class="mt-4"
                    >Editar Usuario</b-button
                  >
                </div>
              </b-form>
            </validation-observer>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
</template>
<script>
import axios from '@/directives/axios.js';
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  name: "register",
  data() {
    return {
      nombre: "",
      email: "",
      password: "",
      id: "",
    };
  },
  created() {
    var data = this.$store.getters.getDatosUsuario;
    this.email = data.email;
    this.nombre = data.name;
    this.id = data.id;
  },
  methods: {
    onSubmit() {
      loader.open();
      let data = undefined;
      if (this.password != "") {
        data = {
          name: this.nombre,
          email: this.email,
          password: this.password,
          id: this.id,
        };
      } else {
        data = {
          name: this.nombre,
          email: this.email,
          id: this.id,
        };
      }
      axios({
        method: "POST",
        url: `/register`,
        withCredentials: true,
        data: data,
      })
        .then((data) => {
          loader.close();
          swal
            .fire({
              title: `Datos Guardados Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            });
        })
        .catch((erro) => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
  },
};
</script>
<style></style>
